export default __webpack_public_path__ + "static/media/640_store01-nl-mobile.89c8b112.png";